import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import AutoSaveTextField from '../../../../../../../../common/components/AutoSaveTextField';

const ShortDeliveryInputComponent = ({ value, scrapId, disabled, handleUpdate }) => {
    const { t } = useTranslation();

    const handleBlur = event => {
        const newValue = +event.target.value;

        if (value !== newValue) {
            handleUpdate(
                `scraps.$[scrapId]`,
                {
                    scrap: { piecesToDeliver: newValue },
                },
                'update',
                { scrapId }
            );
        }
    };

    return (
        <AutoSaveTextField
            onlyPositiveDigits
            type="number"
            value={value}
            disabled={disabled}
            label={t('ncrInfo.immediate.shortDeliveryInputLabel')}
            onBlur={handleBlur}
            onKeyPress={event => {
                event.key === 'Enter' && handleBlur(event);
            }}
            fullWidth
        />
    );
};

const ShortDeliveryInput = memo(ShortDeliveryInputComponent);

export default ShortDeliveryInput;
